import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ['template', 'container']

  append(event) {
    this.containerTarget
      .insertAdjacentHTML('beforeend', this.templateTarget.innerHTML)
  }
}
